import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  RefundRequestResponse,
  UpdateRefundRequestParams,
} from './interfaces';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/subsidy/base';

export const useRefundRequestShow = (refundRequestUuid: string) => {
  const response = useQuery<RefundRequestResponse>({
    queryKey: [clientKeys.useRefundRequestShow, refundRequestUuid],
    queryFn: async () =>
      await falconClient.get(`${baseUrl}/refund_requests/${refundRequestUuid}`),
  });

  return {
    refundRequest: response?.data?.refund_request,
    ...response,
  };
};

export const useCreateRefundRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ formData }: { formData: FormData }) =>
      await falconClient.post(`${baseUrl}/refund_requests`, formData),
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: [clientKeys.useRefundRequestShow],
      });
    },
  });
};

export const useUpdateRefundRequest = () => {
  return useMutation({
    mutationFn: async ({ formData, id }: UpdateRefundRequestParams) => {
      return await falconClient.put<RefundRequestResponse>(
        `${baseUrl}/refund_requests/${id}`,
        formData
      );
    },
  });
};
